// Globo renders the preview; Dawn and Kaching own the purchasable variants.
// Keep their display aligned without dispatching changes that reset mixed bundles.
(() => {
  const configElement = document.getElementById('PandaizeVariantAvailability');
  const root = document.querySelector('[id^="MainProduct-"]');
  if (!configElement || !root || root.dataset.pandaizeAvailabilityReady) return;
  const config = JSON.parse(configElement.textContent);
  const byId = new Map(config.variants.map(variant => [String(variant.id), variant]));
  const byColor = new Map(config.variants.map(variant => [variant.title, variant]));
  const info = root.querySelector('[id^="ProductInfo-"]') || root;
  const swatchSelector = 'input[name="globo-option-0"]';
  const nativeSelector = 'variant-radios input[type="radio"], variant-selects select';
  const bundleSelector = '.kaching-bundles__bar--selected .kaching-bundles__bar-variant-selector-wrapper select.kaching-bundles-option';
  const formSelector = 'form[action*="/cart/add"]';
  let selected = byId.get(String(config.selected));
  let blocked = selected && !selected.available ? selected : null;
  let gestureInput = null;
  let frame;
  root.dataset.pandaizeAvailabilityReady = 'true';

  const message = document.createElement('p');
  message.dataset.pandaizeAvailabilityMessage = '';
  message.setAttribute('role', 'status');
  message.setAttribute('aria-live', 'polite');
  message.hidden = true;

  function setMessage(text) {
    if (!message.isConnected) {
      const swatches = info.querySelector('.swatch--gl');
      if (swatches) swatches.after(message);
      else info.prepend(message);
    }
    if (message.textContent !== text) message.textContent = text;
    if (message.hidden !== !text) message.hidden = !text;
  }

  function soldOut(variant) {
    return `${variant.title} — ${config.soldOut}. Please choose an available color.`;
  }

  function syncPreview(variant) {
    if (!variant) return;
    info.querySelectorAll(swatchSelector).forEach(input => {
      input.checked = input.value === variant.title;
    });
    info.querySelectorAll('.swatch--gl .name-variant').forEach(label => {
      const text = `: ${variant.title}`;
      if (label.textContent !== text) label.textContent = text;
    });
  }

  function refresh() {
    frame = null;
    info.querySelectorAll(swatchSelector).forEach(input => {
      const variant = byColor.get(input.value);
      if (!variant || variant.available) return;
      if (!input.disabled) input.disabled = true;
      const item = input.closest('li');
      if (!item) return;
      if (!item.hasAttribute('data-pandaize-sold-out')) item.dataset.pandaizeSoldOut = '';
      const label = item.querySelector('label');
      if (label?.getAttribute('aria-disabled') !== 'true') label?.setAttribute('aria-disabled', 'true');
      if (!item.querySelector('[data-pandaize-sold-out-label]')) {
        const badge = document.createElement('span');
        badge.dataset.pandaizeSoldOutLabel = '';
        badge.textContent = config.soldOut;
        item.append(badge);
      }
      const accessibleName = `${variant.title} — ${config.soldOut}`;
      if (input.getAttribute('aria-label') !== accessibleName) input.setAttribute('aria-label', accessibleName);
    });
    if (!info.querySelector(`${swatchSelector}:checked`)) syncPreview(selected);
    info.querySelectorAll(`${formSelector} button[name="add"]`).forEach(button => {
      if (blocked) {
        if (!button.hasAttribute('data-pandaize-availability-disabled')) button.dataset.pandaizeAvailabilityDisabled = '';
        if (!button.disabled) button.disabled = true;
      } else if (button.hasAttribute('data-pandaize-availability-disabled')) {
        button.removeAttribute('data-pandaize-availability-disabled');
        button.disabled = false;
      }
    });
    if (blocked) setMessage(soldOut(blocked));
  }

  function scheduleRefresh() {
    if (!frame) frame = requestAnimationFrame(refresh);
  }

  function stop(event, text) {
    event.preventDefault();
    event.stopImmediatePropagation();
    setMessage(text);
    scheduleRefresh();
  }

  function inputFor(target) {
    const label = target.closest('label[for]');
    const input = label ? document.getElementById(label.htmlFor) : target;
    return input?.matches(`${swatchSelector}, ${nativeSelector}`) ? input : null;
  }

  // App startup emits synthetic clicks/changes while falling back from a sold-out
  // URL. Only a real pointer/keyboard choice may dismiss that original request.
  function customerChoice(input) {
    const sameRadioGroup = gestureInput?.type === 'radio' && input.type === 'radio' &&
      gestureInput.name === input.name;
    return gestureInput === input || sameRadioGroup;
  }

  ['pointerdown', 'keydown'].forEach(type => window.addEventListener(type, event => {
    if (!(event.target instanceof Element) || !info.contains(event.target)) {
      gestureInput = null;
      return;
    }
    gestureInput = inputFor(event.target) || event.target.closest(bundleSelector);
  }, true));

  function purchaseError() {
    if (blocked) return soldOut(blocked);
    const preview = info.querySelector(`${swatchSelector}:checked`);
    const shown = preview ? byColor.get(preview.value) : selected;
    if (shown && !shown.available) return soldOut(shown);
    const form = info.querySelector(formSelector);
    const submitted = byId.get(form?.querySelector('[name="id"]')?.value);
    const colors = Array.from(info.querySelectorAll(bundleSelector), select => byColor.get(select.value));
    // A bundle may contain different colors. The preview must match the last
    // edited item, while every item must independently remain purchasable.
    if (!shown || !submitted?.available || shown.id !== submitted.id ||
        colors.some(variant => !variant?.available) ||
        (colors.length && !colors.some(variant => variant.id === shown.id))) {
      return 'Please select your color again before adding to cart.';
    }
    return '';
  }

  // Window capture runs before app handlers on the document/form/button. This
  // also protects the add while Kaching re-enables a previously disabled button.
  window.addEventListener('click', event => {
    if (!(event.target instanceof Element) || !info.contains(event.target)) return;
    const input = inputFor(event.target);
    if (input) {
      const variant = byColor.get(input.value);
      if (!variant) return;
      const deliberate = customerChoice(input);
      gestureInput = null;
      if (!variant.available) {
        blocked = variant;
        stop(event, soldOut(variant));
      } else if (!blocked || deliberate) {
        selected = variant;
        blocked = null;
        setMessage('');
        scheduleRefresh();
      }
      return;
    }
    const purchase = event.target.closest('button[name="add"], .shopify-payment-button, [id="more-payment-options-link"]');
    if (purchase) {
      const error = purchaseError();
      if (error) stop(event, error);
    }
  }, true);

  window.addEventListener('submit', event => {
    if (!info.contains(event.target) || !event.target.matches(formSelector)) return;
    const error = purchaseError();
    if (error) stop(event, error);
  }, true);

  window.addEventListener('change', event => {
    if (!(event.target instanceof Element) || !info.contains(event.target)) return;
    const input = event.target;
    if (!input.matches(`${swatchSelector}, ${nativeSelector}, ${bundleSelector}`)) return;
    const variant = byColor.get(input.value);
    if (!variant) return;
    if (!variant.available) {
      blocked = variant;
      stop(event, soldOut(variant));
      return;
    }
    // App-generated native fallbacks must not count as customer choices.
    if (customerChoice(input)) blocked = null;
    gestureInput = null;
    if (!blocked) {
      selected = variant;
      syncPreview(variant);
      setMessage('');
    }
    scheduleRefresh();
  }, true);

  new MutationObserver(scheduleRefresh).observe(info, {
    childList: true, subtree: true, attributes: true, attributeFilter: ['disabled']
  });
  refresh();
})();
